import styled from "styled-components";
import { colors, breakpoints } from "definitions";
import { HorizontalLine } from "App/styles";

export const Container = styled.div`
  background-color: #451CB8;
  height: auto;

  width: 100%;
  max-width: 124.5rem;

  /* shadow + radius los maneja el Modal padre; acá solo padding interno
     para que los inputs no queden pegados al borde. */
  padding: 2.4rem;

  /* Los campos los arma cada form de entidad y llegan como hijos directos del
     form, sin separación propia: el rótulo de un campo quedaba pegado al input
     del anterior. El gap los separa a todos por igual, y el divisor de arriba
     de los botones renuncia a su margen para no sumarse al gap. */
  form {
    display: flex;
    flex-direction: column;
    gap: 1.8rem;
  }

  ${HorizontalLine} {
    margin: 0;
  }

  ${breakpoints.tablet} {
    padding: 1.6rem;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 1rem;
  align-items: stretch;

  ${breakpoints.tablet} {
    flex-direction: column-reverse;
  }
`;

// Botón secundario para Cancelar dentro del form (outline blanco sobre fondo purple).
export const CancelFormButton = styled.button`
  flex: 0 0 auto;
  min-width: 14rem;
  padding: 0 1.6rem;
  background: transparent;
  border: 2px solid #ffffff;
  border-radius: 6px;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  height: 4.8rem;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: #ffffff;
    color: #451cb8;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  ${breakpoints.tablet} {
    width: 100%;
  }
`;

export const SaveButtonWrapper = styled.div`
  flex: 1;
`;
